import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import AppContext from '@/contexts/appContext';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const RedirectWithError = ({ to, message }: Props) => {
  const { addMessage } = useContext(AppContext);
  useEffect(() => {
    addMessage('error', message);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Navigate to={to} replace />;
};

export default React.memo(RedirectWithError);
